import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

import { classes as fileUploaderClasses } from "@/components/inference-forms/common/FileUploader/FileUploader";
import { classes as uploadClasses } from "@/components/inference-forms/common/Upload/components/Upload";

export const UploadRoot = styled(Stack)({
  [`& .${uploadClasses.root}`]: {
    padding: 0,
    backgroundColor: "transparent",
  },
  [`& .${uploadClasses.uploadBox}`]: {
    width: "100%",
  },
  [`& .${fileUploaderClasses.container}`]: {
    width: "100%",
  },
});
